





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import NotificationModel from '../../models/notification'
import { ROUTER_NAME } from '../../router'
import { notificationState } from '../../stores/notification'

@Component({})
export default class Notification extends Vue {
  @Prop({ default: null }) item: NotificationModel
  @Prop({ default: null }) mobile: boolean

  goDetailAction() {
    notificationState.markReaded({ id: this.item.id })

    switch(this.item.action) {
      case 'marked_exam':
        return this.$router.push({
          name: 'exam-result',
          params: {
            examId: this.item.target.examId.toString(),
          },
          query: {
            user_exam_id: this.item.target.id.toString()
          }
        })
      case 'comment':
        if (this.item.target.commentableType == 'Question') {
          return this.$router.push({
            name: 'user-question-detail',
            params: {
              questionId: this.item.target.commentableId.toString()
            },
            hash: `#comment-${this.item.target.id}`
          })
        }
        if (this.item.target.commentableType == 'Answer') {
          return this.$router.push({
            name: 'user-question-detail',
            params: {
              questionId: this.item.target.questionId.toString()
            },
            hash: `#comment-${this.item.target.id}`
          })
        }
        if (this.item.target.commentableType == 'Inquiry') {
          return this.$router.push({
            name: ROUTER_NAME.INQUIRY_DETAIL,
            params: {
              inquiryId: this.item.target.commentableId.toString()
            }
          })
        }
        if (this.item.target.commentableType == 'UserExam') {
          return this.$router.push({
            name: ROUTER_NAME.EXAM_RESULT,
            params: {
              examId: this.item.target.examId.toString()
            },
            query: {
              user_exam_id: this.item.target.id.toString()
            },
            hash: `#comment-${this.item.target.id}`
          })
        }
      case 'ask':
        return this.$router.push({
          name: 'user-question-detail',
          params: {
            questionId: this.item.target.id.toString()
          }
        })
        break
      case 'answer':
        return this.$router.push({
          name: 'user-question-detail',
          params: {
            questionId: this.item.target.questionId.toString()
          },
          hash: `#answer-${this.item.target.id}`
        })
      case 'information': 
        return this.$router.push({
          name: 'infor-detail',
          params: {
            inforId: this.item.targetId.toString()
          }
        })
      case 'inquiry': 
        return this.$router.push({
          name: ROUTER_NAME.INQUIRY_DETAIL,
          params: {
            inquiryId: this.item.targetId.toString()
          }
        })
      case 'teacher_approved_booking':
        return location.href = '/classroom/appointment#/events/' + this.item.targetId.toString()
      case 'zoom_ready':
        return location.href = '/classroom/appointment#/events/' + this.item.targetId.toString()
      case 'teacher_rejected_booking':
        return location.href = '/classroom/appointment#/events/' + this.item.targetId.toString()
      case 'create_booking': // for teacher
        return location.href = this.item.url
      case 'course_purchase': // for admin
        return location.href = this.item.url
    }
  }
}
